import type { FrameworkDefinition, WarSummary } from '@dwa/shared';
import { useQuery } from '@tanstack/react-query';
import * as api from '../api/endpoints';

/** Loads a WAR's framework content from the API (DynamoDB-backed). Cached per focus. */
export function useFramework(focus?: string) {
  return useQuery<FrameworkDefinition>({
    queryKey: ['framework', focus ?? 'default'],
    queryFn: () => api.getFramework(focus).then((r) => r.framework),
    staleTime: Infinity,
  });
}

/** Loads the catalog of available WARs. */
export function useWars() {
  return useQuery<WarSummary[]>({
    queryKey: ['wars'],
    queryFn: () => api.getWars().then((r) => r.wars),
    staleTime: Infinity,
  });
}
